// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://uahbodywjqrukpeztjzq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVhaGJvZHl3anFydWtwZXp0anpxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ3OTE1MjksImV4cCI6MjA4MDM2NzUyOX0.7ewL4xvn33yoRVQxAOOof6ZthUwLQ21hsKqMaOWxEKs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
